export default __webpack_public_path__ + "static/media/ToolIcon.f246aaf0.jpg";